import { Info } from "lucide-react";

interface NoticeProps {
  message: string;
  variant?: "warning" | "error";
}

export function Notice({ message, variant = "warning" }: NoticeProps) {
  const isError = variant === "error";

  return (
    <div
      className={`p-4 w-full rounded-lg ${
        isError ? "bg-red-500/10" : "bg-[#FACC151A]"
      }`}
    >
      <div className="flex gap-2">
        <Info
          className={`flex-shrink-0 ${
            isError ? "text-red-500" : "text-[#FACC15]"
          }`}
          size={16}
        />
        <p className="text-sm text-zinc-400 whitespace-pre-line">{message}</p>
      </div>
    </div>
  );
}
